import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {MainComponent} from './main.component';
import {ContentComponent} from './content.component';
import {NavigationModule} from './comp/navigation/navigation.module';
import {AnnouncementModule} from '../views/common/dialog-announcement/announcement.module';
import {GlobalModule} from '@app/core/global/global.module';
import {SharedMainModule} from '@app/core/modules/shared-main.module';
import {MaintenanceComponent} from '@app/views/common/maintenance/maintenance.component';
import {NgcLoginComponent} from '@app/views/common/login/login.component';
import {NgcTermsOfUseComponent} from '@app/views/common/terms-of-use/terms-of-use.component';
import {VersionComponent} from '@app/views/common/version/version.component';
import {ResetPasswordComponent} from '@app/views/common/reset-password/reset-password.component';
import {ForgotPasswordComponent} from '@app/views/common/forgot-password/forgot-password.component';
import {StandardPageComponent} from '@app/core/comp/standard-page/standard-page.component';
import {PageNotFoundComponent} from '@app/core/comp/navigation/not-found-page/page-not-found.component';
import {NavbarComponent} from '@app/core/comp/navigation/navbar/navbar.component';
import {SetUserPasswordComponent} from '@app/views/common/set-password/set-password.component';
import {AuthSamlComponent} from '@app/views/common/login/auth-saml/auth-saml.component';
import {AuthOauthComponent} from '@app/views/common/login/auth-oauth/auth-oauth.component';
import {AuthErrorComponent} from '@app/views/common/login/auth-error/auth-error.component';
import {routes} from '@app/core/main.module.routes';
import {CredentialsLoginComponent} from '@app/views/common/login/credentials-login/credentials-login.component';
import {MFALoginComponent} from '@app/views/common/login/mfa-login/mfa-login.component';
import {RecoveryCodeLoginComponent} from '@app/views/common/login/recovery-code-login/recovery-code-login.component';
import {LoginAsSelectorComponent} from '@app/views/common/login/login-as-selector/login-as-selector.component';
import { DatetimeRangeDialogComponent } from './comp/dialog/datetime-range-dialog/datetime-range-dialog.component';
import {MFASetupComponent} from '@app/views/common/login/mfa-set-up/mfa-setup.component';
import {AccountExpiredComponent} from '@app/views/common/account-expired/account-expired.component';

@NgModule({
    declarations: [
        ContentComponent,
        MainComponent,
        VersionComponent,
        NgcLoginComponent,
        LoginAsSelectorComponent,
        NgcTermsOfUseComponent,
        MaintenanceComponent,
        AccountExpiredComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        SetUserPasswordComponent,
        StandardPageComponent,
        PageNotFoundComponent,
        NavbarComponent,
        AuthSamlComponent,
        AuthOauthComponent,
        AuthErrorComponent,
        CredentialsLoginComponent,
        MFALoginComponent,
        MFASetupComponent,
        RecoveryCodeLoginComponent,
        DatetimeRangeDialogComponent,
    ],
    imports: [
        GlobalModule,
        SharedMainModule,
        NavigationModule,
        AnnouncementModule,
        RouterModule.forChild(routes)
    ],
    exports: [
        SharedMainModule,
        NavigationModule,
        MainComponent,
        StandardPageComponent,
        PageNotFoundComponent,
        NavbarComponent
    ],
    providers: [
        MainComponent
    ]
})

export class MainModule {
}
